import { AutocompleteRenderGroupParams } from '@mui/material/Autocomplete/Autocomplete'
import { Typography } from '@mui/material'
import styles from './AutocompleteGroup.module.scss'

export type AutocompleteGroupProps = {
  group: AutocompleteRenderGroupParams
}

export const AutocompleteGroup = (props: AutocompleteGroupProps) => {
  const { group } = props

  return (
    <div className={styles.wrapper}>
      <Typography variant="bodyBold">{group.group}</Typography>
      <div className={styles.items}>{group.children}</div>
    </div>
  )
}
